var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoggedIn)?_c('LandingNoLogin'):_vm._e(),(_vm.isLoggedIn && _vm.isUser)?_c('LandingUser'):_vm._e(),(_vm.isLoggedIn && !_vm.isUser)?_c('LandingCust'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }